import { render } from "./ProviderView.vue?vue&type=template&id=5fdd9d57&ts=true"
import script from "./ProviderView.vue?vue&type=script&lang=ts"
export * from "./ProviderView.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__